import React from 'react';
import { Container } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';

import './PricePage.css';

const PricePage = () => {
  return (
    <div className="about-page">
      <Container>
        {/* Page Title */}
        <h2>
          <FontAwesomeIcon className="page-title-icon" icon={faInfo} />
          <span className="page-title">Price Page</span>
        </h2>
        {/* End Page Title */}
        {/* Page Content */}
        {/* End Page Content */}
      </Container>
    </div>
  );
};

export default PricePage;